function getConversationOpk(url) {
  if (!url) {
    return '';
  }
  const match = url.match(/conversations\/([a-zA-z0-9]+)\/$/);
  if (!match) {
    return '';
  }
  return match[1] || '';
}

export default getConversationOpk;



// WEBPACK FOOTER //
// ../utilities/conversation.js